<template>
  <div class="ddhj-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="报价日期">
              <el-date-picker
                v-model="searchForm.time"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="daterange"
                style="width:300px"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              />
            </el-form-item>
            <el-form-item label="订单类型">
              <el-select v-model="searchForm.type" style="width: 120px" filterable clearable @keyup.enter.native="Search">
                <el-option-group label="">
                  <el-option label="正单" :value="0" />
                  <el-option label="补单" :value="5" />
                </el-option-group>
                <el-option-group label="补单类型">
                  <el-option label="客改单" :value="1" />
                  <el-option label="增补单" :value="2" />
                  <el-option label="色板单" :value="3" />
                  <el-option label="售后单" :value="4" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search" />
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" plain @click="dialogVisible = true">导出汇总</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="loading" :span="24">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  style="width: 100%"
                  @row-click="openDetails"
                >
                  <el-table-column
                    label="订单号"
                    width="120"
                    fixed
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.ordernum }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    fixed
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.produnum!==null&&scope.row.produnum!==''&&scope.row.produnum!==undefined" style="font-weight: 500;color:#409EFF">{{ scope.row.produnum }}</span>
                      <span v-if="scope.row.produnum===null||scope.row.produnum===''||scope.row.produnum===undefined" style="font-weight: 500;color:#999999">N/A</span>
                    </template>
                  </el-table-column>
                  <!--                  <el-table-column-->
                  <!--                    label="经销商"-->
                  <!--                    width="120"-->
                  <!--                    show-overflow-tooltip>-->
                  <!--                    <template slot-scope="scope">-->
                  <!--                      <span><i class="el-icon-user"></i> {{scope.row.delname}}</span>-->
                  <!--                    </template>-->
                  <!--                  </el-table-column>-->
                  <!--                  <el-table-column-->
                  <!--                    label="订单类型"-->
                  <!--                    width="110"-->
                  <!--                    show-overflow-tooltip>-->
                  <!--                    <template slot-scope="scope">-->
                  <!--                      <span style="color:#99a9bf">类型：</span>-->
                  <!--                      <span v-if="scope.row.type===0">正单</span>-->
                  <!--                      <span v-if="scope.row.type===1">客改单</span>-->
                  <!--                      <span v-if="scope.row.type===2">增补单</span>-->
                  <!--                      <span v-if="scope.row.type===3">色板单</span>-->
                  <!--                      <span v-if="scope.row.type===4">售后单</span>-->
                  <!--                    </template>-->
                  <!--                  </el-table-column>-->
                  <el-table-column
                    label="详细地址"
                    width="160"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.address }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="总报价"
                    width="140"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409eff;">{{ scope.row.amount }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="折扣"
                    width="70"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.discount>0" :disable-transitions="true" size="mini" type="danger">{{ scope.row.discount }}</el-tag>
                      <el-tag v-if="scope.row.discount<=0" :disable-transitions="true" size="mini" type="info">0折</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="优惠"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.best>0" style="color:#f56c6c;font-weight: 500">{{ scope.row.best }}</span>
                      <span v-if="scope.row.best<=0">0</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="设计承担"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.designcom>0" style="color:#f56c6c;font-weight: 500">{{ scope.row.designcom }}</span>
                      <span v-if="scope.row.designcom<=0">0</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="工厂承担"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.factorycom>0" style="color:#f56c6c;font-weight: 500">{{ scope.row.factorycom }}</span>
                      <span v-if="scope.row.factorycom<=0">0</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="客户承担"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.clientcom>0" style="color:#f56c6c;font-weight: 500">{{ scope.row.clientcom }}</span>
                      <span v-if="scope.row.clientcom<=0">0</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="报价备注"
                    min-width="200"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.remark!==''&&scope.row.remark!==null&&scope.row.remark!==undefined">{{ scope.row.remark }}</span>
                      <span v-if="scope.row.remark===''||scope.row.remark===null||scope.row.remark===undefined">N/A</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="报价员"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.username }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="报价时间"
                    width="170"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.time }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    fixed="right"
                    align="center"
                    label="操作"
                  >
                    <template slot-scope="scope">
                      <el-button icon="el-icon-search" size="mini" @click.stop="view(scope.row)">查看详情</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                />
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :visible.sync="dialogVisible"
      width="420px"
      title="订单汇总表"
    >
      <el-form label-position="right" label-width="90px" size="small" :model="searchForm2">
        <el-form-item label="订单类型">
          <el-select v-model="searchForm2.type" style="width: 120px" filterable clearable>
            <el-option-group label="">
              <el-option label="正单" :value="0" />
              <el-option label="补单" :value="5" />
            </el-option-group>
            <el-option-group label="补单类型">
              <el-option label="客改单" :value="1" />
              <el-option label="增补单" :value="2" />
              <el-option label="色板单" :value="3" />
              <el-option label="售后单" :value="4" />
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="订单日期">
          <el-date-picker
            v-model="searchForm2.time"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            type="daterange"
            style="width:300px"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" icon="el-icon-printer" :loading="exportLoading" @click="exportExcel">导出</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="订单报价详情"
      :visible.sync="infoVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <div v-loading="infoloading" style="font-size: 13px;color:#606266;padding: 0 20px">
        <div v-if="afterInfo!==null&&afterInfo!==undefined" style="margin-bottom: 15px">
          <span style="color:#99a9bf">售后处理人：</span>
          <span>{{ afterInfo.treat_user }}</span>
          <span style="color:#99a9bf;margin-left: 20px">处理时间：</span>
          <span>{{ afterInfo.treat_time }}</span>
          <div style="margin-top: 15px">
            <span style="color:#99a9bf">售后返修单：</span>
            <span class="tcf-link" @click="downFile(afterInfo.fileid)"><i class="el-icon-download" /> {{ afterInfo.file_name }}</span>
          </div>
          <div style="margin-top: 15px">
            <span style="color:#99a9bf">售后判定单：</span>
            <el-image
              style="width: 60px; height: 60px;"
              fit="cover"
              :preview-src-list="[afterInfo.img_url]"
              :src="afterInfo.img_url"
            />
          </div>
          <div v-if="afterInfo.remark!==null&&afterInfo.remark!==''&&afterInfo.remark!==undefined" style="margin-top: 15px">
            <span style="color:#99a9bf">售后备注：</span>
            <span>{{ afterInfo.remark }}</span>
          </div>
        </div>
        <div>
          <span style="color:#99a9bf">报价员：</span>
          <span>{{ infoData.username }}</span>
          <span style="color:#99a9bf;margin-left: 20px">报价时间：</span>
          <span>{{ infoData.time }}</span>
        </div>
        <div style="margin-top: 15px">
          <span style="color:#99a9bf">报价单：</span>
          <span class="tcf-link" @click="downFile(offerInfo.fileid)"><i class="el-icon-download" /> {{ offerInfo.file_name }}.{{ offerInfo.file_ext }}</span>
        </div>
        <div style="margin-top: 15px">
          <template>
            <el-table
              size="mini"
              :data="orderquotedata"
              style="width: 100%"
            >
              <el-table-column
                align="center"
                prop="year"
                label="年份"
                width="60"
              />
              <el-table-column
                prop="name"
                label="报价书编号"
                mini-width="280"
              />
            </el-table>
          </template>
        </div>
        <el-card shadow="hover" style="margin-top: 15px">
          <div>
            <span style="color:#99a9bf">墙板：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.wall }}</span>元
            <span style="color:#99a9bf;margin-left: 20px">柜体：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.cabinet }}</span>元
            <span style="color:#99a9bf;margin-left: 20px">门类：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.door }}</span>元
          </div>
          <div style="margin-top: 15px">
            <span style="color:#99a9bf;">铝材：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.aluminum }}</span>元
            <span style="color:#99a9bf;margin-left: 20px;">配件：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px;">{{ offerInfo.access }}</span>元
          </div>
          <div style="margin-top: 15px">
            <span style="color:#99a9bf">加价：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.raise }}</span>元
            <span style="color:#99a9bf;margin-left: 20px">优惠：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.best }}</span>元
            <span style="color:#99a9bf;margin-left: 20px">折扣：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.discount }}</span>折
          </div>
        </el-card>
        <el-card v-if="offerAccountReceipt.length>0" shadow="hover" style="margin-top: 15px">
          <span style="color:#99a9bf">折扣/优惠</span>
          <el-table
            :data="offerAccountReceipt"
            size="mini"
            :show-header="false"
            style="width: 100%"
          >
            <el-table-column
              prop="name"
              show-overflow-tooltip
              label="折扣/优惠名称"
              min-width="120"
            />
            <el-table-column
              width="120"
              align="right"
              show-overflow-tooltip
              label="优惠金额"
            >
              <template slot-scope="scope">
                <span style="color:#F56C6C;margin-right: 6px">{{ scope.row.money }}</span>元
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <el-card v-if="offerInfo.other>0" shadow="hover" style="margin-top: 15px">
          <span style="color:#99a9bf">其他费用：</span>
          <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.other }}</span>元
          <el-table
            :data="offerOther"
            size="mini"
            :show-header="false"
            style="width: 100%"
          >
            <el-table-column
              show-overflow-tooltip
              label="费用名称"
              min-width="120"
            >
              <template slot-scope="scope">
                <el-tag v-if="scope.row.type===1" :disable-transitions="true" size="mini" type="warning">木架</el-tag>
                <el-tag v-if="scope.row.type===2&&user.group_nature!==1" :disable-transitions="true" size="mini" type="success">调色</el-tag>
                <el-tag v-if="scope.row.type===3" :disable-transitions="true" size="mini" type="info">水性漆</el-tag>
                <span :style="scope.row.type===1?'margin-left: 6px':scope.row.type===2&&user.group_nature!==1?'margin-left: 6px':scope.row.type===3?'margin-left: 6px':''">{{ scope.row.type===2&&user.group_nature===1?'其他费用':scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              align="right"
              show-overflow-tooltip
              label="金额"
            >
              <template slot-scope="scope">
                <span style="color:#F56C6C;margin-right: 6px">{{ scope.row.amount }}</span>元
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <el-card v-if="offerInfo.changes>0" shadow="hover" style="margin-top: 15px">
          <span style="color:#99a9bf">更改单费用：</span>
          <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.changes }}</span>元
          <el-table
            :data="offerChanges"
            size="mini"
            :show-header="false"
            style="width: 100%"
          >
            <el-table-column
              prop="num"
              label="更改单号"
              width="200"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-tag v-if="scope.row.type===0" :disable-transitions="true" size="mini" style="margin-right: 6px" type="danger">设计变更</el-tag>
                <el-tag v-if="scope.row.type===1" :disable-transitions="true" size="mini" style="margin-right: 6px" class="tcf-tag-4">材质变更</el-tag>
                <el-tag v-if="scope.row.type===2" :disable-transitions="true" size="mini" style="margin-right: 6px" class="tcf-tag-6">暂停生产</el-tag>
                <el-tag v-if="scope.row.type===3" :disable-transitions="true" size="mini" style="margin-right: 6px" class="tcf-tag-7">取消订单</el-tag>
                <el-tag v-if="scope.row.type===4" :disable-transitions="true" size="mini" style="margin-right: 6px" class="tcf-tag-2">颜色变更</el-tag>
                <el-tag v-if="scope.row.type===5" :disable-transitions="true" size="mini" style="margin-right: 6px" type="warning">通知单</el-tag>
                <el-tag v-if="scope.row.type===6" :disable-transitions="true" size="mini" style="margin-right: 6px" class="tcf-tag-10">其他</el-tag>
                {{ scope.row.num }}
              </template>
            </el-table-column>
            <el-table-column
              prop="content"
              label="变更内容"
              min-width="200"
              show-overflow-tooltip
            />
            <el-table-column
              label="更改费用"
              width="100"
              fixed="right"
              align="right"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span style="color:#f56c6c">{{ scope.row.amount }}</span>元
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="100"
              fixed="right"
              align="right"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-button type="text" icon="el-icon-search" size="mini" @click="viewOrderChange(scope.row)">详细</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <div style="margin-top: 15px">
          <span style="color:#99a9bf">总报价：</span>
          <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{ offerInfo.amount }}</span>元
          <s v-if="offerInfo.amount!==offerInfo.totalprice" style="margin-left: 10px;color:#999;">{{ offerInfo.totalprice }}</s>
        </div>
        <div v-if="offerInfo.factorycom>0||offerInfo.designcom>0" style="margin-top: 15px">
          <span style="color:#99a9bf">设计承担：</span>
          <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{ offerInfo.designcom }}</span>元
          <span style="color:#99a9bf;margin-left: 20px">工厂承担：</span>
          <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{ offerInfo.factorycom }}</span>元
          <span style="color:#99a9bf;margin-left: 20px">客户承担：</span>
          <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{ offerInfo.clientcom }}</span>元
        </div>
        <div v-if="offerImgs!==null&&offerImgs!==undefined&&offerImgs.length>0" style="margin-top: 15px">
          <span style="color:#99a9bf">领导凭证：</span>
          <el-image
            v-for="img in offerImgs"
            style="width: 50px; height: 50px;margin-right: 10px"
            :src="img"
            :preview-src-list="offerImgs"
            fit="cover"
          />
        </div>
        <div v-if="offerInfo.remark!==null&&offerInfo.remark!==''&&offerInfo.remark!==undefined" style="margin-top: 15px">
          <span style="color:#99a9bf">备注：</span>
          <span>{{ offerInfo.remark }}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="infoVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="viewOrderChangeTitle"
      :visible.sync="viewOrderChangeVisible"
      width="1120px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-row v-loading="viewOrderChangeLoading">
        <el-col :span="10">
          <table class="tcf-detail-table">
            <tr>
              <th>更改单号</th>
              <td>{{ viewOrderChangeData.oc.num }}</td>
              <th>生产单号</th>
              <td>{{ viewOrderChangeData.oc.produnum }}</td>
            </tr>
            <tr>
              <th>详细地址</th>
              <td colspan="3">{{ viewOrderChangeData.oc.address }}</td>
            </tr>
            <tr>
              <th>变更类别</th>
              <td>
                <span v-if="viewOrderChangeData.oc.type===0">设计变更</span>
                <span v-if="viewOrderChangeData.oc.type===1">材质变更</span>
                <span v-if="viewOrderChangeData.oc.type===2">暂停生产</span>
                <span v-if="viewOrderChangeData.oc.type===3">取消订单</span>
                <span v-if="viewOrderChangeData.oc.type===4">颜色变更</span>
                <span v-if="viewOrderChangeData.oc.type===5">通知单</span>
                <span v-if="viewOrderChangeData.oc.type===6">其他</span>
              </td>
              <th>申请部门</th>
              <td>
                <span v-if="viewOrderChangeData.oc.dept===0">客户</span>
                <span v-if="viewOrderChangeData.oc.dept===1">拆单</span>
                <span v-if="viewOrderChangeData.oc.dept===2">方案</span>
                <span v-if="viewOrderChangeData.oc.dept===3">车间</span>
                <span v-if="viewOrderChangeData.oc.dept===4">采购</span>
                <span v-if="viewOrderChangeData.oc.dept===5">软件</span>
                <span v-if="viewOrderChangeData.oc.dept===6">其他</span>
                <span v-if="viewOrderChangeData.oc.dept===7">建模</span>
                <span v-if="viewOrderChangeData.oc.dept===8">研发</span>
              </td>
            </tr>
            <tr>
              <th>变更内容</th>
              <td colspan="3">{{ viewOrderChangeData.oc.content }}</td>
            </tr>
            <tr>
              <th>拆单人员</th>
              <td>{{ viewOrderChangeData.oc.splitname }}</td>
              <th>生产动态</th>
              <td style="font-weight: bold;color:#f56c6c">
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===0">PMC阶段</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===1">开料完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===2">组装完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===3">贴皮完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===4">白胚完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===5">做灰完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===6">底漆完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===7">粗磨完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===8">二次底漆完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===9">细磨完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===10">面漆完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===11">包装完工</span>
              </td>
            </tr>
            <tr>
              <th>变更原因</th>
              <td colspan="3">{{ viewOrderChangeData.oc.rson }}</td>
            </tr>
            <tr>
              <th colspan="2" style="text-align: center">变更前内容</th>
              <th colspan="2" style="text-align: center">变更后内容</th>
            </tr>
            <tr>
              <td colspan="2"><div class="pl">{{ viewOrderChangeData.oc.beforetxt }}</div></td>
              <td colspan="2"><div class="pl">{{ viewOrderChangeData.oc.aftertxt }}</div></td>
            </tr>
            <tr v-if="viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4">
              <th>报价明细</th>
              <td colspan="3">{{ viewOrderChangeData.oc.offerdetail }}</td>
            </tr>
            <tr v-if="viewOrderChangeData.oc.mark>4">
              <th v-if="viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4">报价费用</th>
              <td v-if="viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4" style="font-weight: bold;color:#409EFF">{{ viewOrderChangeData.oc.mark>4?viewOrderChangeData.oc.amount:'' }}</td>
              <th>交期延长</th>
              <td :colspan="viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4?1:3">{{ viewOrderChangeData.oc.mark>6?viewOrderChangeData.oc.day+'天':'' }}</td>
            </tr>
          </table>
        </el-col>
        <el-col :span="5">
          <el-timeline>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>0?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>0?viewOrderChangeData.oc.time:''"
            >
              提交
              <div v-if="viewOrderChangeData.oc.mark>0" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.initname }}<el-tag size="mini" :type="viewOrderChangeData.oc.inittype===0?'':'warning'" style="margin-left: 6px">{{ viewOrderChangeData.oc.initposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>1?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>1?viewOrderChangeData.oc.sercontime:''"
            >
              客服确认
              <div v-if="viewOrderChangeData.oc.mark>1" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.servicename }}<el-tag size="mini" type="success" style="margin-left: 6px">{{ viewOrderChangeData.oc.serviceposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>2?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>2?viewOrderChangeData.oc.pmctime:''"
            >
              生产动态
              <div v-if="viewOrderChangeData.oc.mark>2" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.pmcuname }}<el-tag size="mini" type="warning" style="margin-left: 6px">{{ viewOrderChangeData.oc.pmcuposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>3?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>3?viewOrderChangeData.oc.assesstime:''"
            >
              设计确认
              <div v-if="viewOrderChangeData.oc.mark>3" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.assessname }}<el-tag size="mini" type="danger" style="margin-left: 6px">{{ viewOrderChangeData.oc.assessposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              v-if="viewOrderChangeData.oc.mark<=4||viewOrderChangeData.oc.offerid!==0"
              :type="viewOrderChangeData.oc.mark>4?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>4?viewOrderChangeData.oc.offertime:''"
            >
              更改单报价
              <div v-if="viewOrderChangeData.oc.mark>4" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.offername }}<el-tag size="mini" type="success" style="margin-left: 6px">{{ viewOrderChangeData.oc.offerposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              v-if="viewOrderChangeData.oc.mark<=5||viewOrderChangeData.oc.conid!==0"
              :type="viewOrderChangeData.oc.mark>5?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>5?viewOrderChangeData.oc.contime:''"
            >
              客户确认
              <div v-if="viewOrderChangeData.oc.mark>5" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.conname }}<el-tag size="mini" :type="viewOrderChangeData.oc.contype===0?'':'warning'" style="margin-left: 6px">{{ viewOrderChangeData.oc.conposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>6?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>6?viewOrderChangeData.oc.pmccontime:''"
            >
              PMC确认
              <div v-if="viewOrderChangeData.oc.mark>6" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.pmcconname }}<el-tag size="mini" type="danger" style="margin-left: 6px">{{ viewOrderChangeData.oc.pmcconposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark===100?'primary':''"
            >
              完成
            </el-timeline-item>
          </el-timeline>
        </el-col>
        <el-col :span="9" class="tcf-order-change-remark">
          <div class="title">
            <span>更改单备注</span>
          </div>
          <div v-if="viewOrderChangeData.ocrlst.length===0" class="order-dynamic-not">
            暂无更改单备注数据
          </div>
          <div class="content-list">
            <div v-for="d in viewOrderChangeData.ocrlst" class="order-dynamic-item">
              <div class="photo">
                <el-avatar shape="square" :size="50" :src="d.photo" />
              </div>
              <div class="info">
                <div class="username"><span>{{ d.username }}</span><el-tag v-if="d.posname!==null&&d.posname!==''&&d.posname!==undefined" :type="d.color===0?'':d.color===1?'success':d.color===2?'warning':''" size="mini">{{ d.posname }}</el-tag></div>
                <div class="time"><i class="el-icon-time" /> {{ d.time }}</div>
                <div class="content">
                  <div v-if="d.ispub===1" style="color:#f56c6c;"><i class="el-icon-lock" /> 仅组织员工可见，经销商无法查看</div>
                  <el-tag v-if="d.ctype===1" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">客服确认驳回</el-tag>
                  <el-tag v-if="d.ctype===2" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">生产动态驳回</el-tag>
                  <el-tag v-if="d.ctype===3" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">设计确认驳回</el-tag>
                  <el-tag v-if="d.ctype===4" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">报价驳回</el-tag>
                  <el-tag v-if="d.ctype===5" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">客户确认驳回</el-tag>
                  <el-tag v-if="d.ctype===6" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">PMC确认驳回</el-tag>
                  {{ d.content }}
                </div>
                <div class="files">
                  <div v-for="f in d.filelst" class="file-item" @click="downFile(f.fileid)">
                    <i class="el-icon-document" />
                    <div class="file-name">{{ f.file_name }}.{{ f.file_type }}</div>
                  </div>
                </div>
                <div class="imgs">
                  <el-image
                    v-for="img in d.imglst"
                    fit="cover"
                    class="dynamic-img"
                    :src="img"
                    :preview-src-list="d.imglst"
                  />
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  getOrderNuclearPriceDetail,
  getOrderSelectPriceList,
  getOrderChangeDetail, exportOrderQueryPriceExcel
} from '@/api/erp'
import { getFileInfo } from '@/api/pub'

export default {
  name: 'Ddcj',
  data() {
    return {
      exportLoading: false,
      dialogVisible: false,
      search: '',
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      searchForm: {
        search: '',
        type: '',
        time: []
      },
      searchForm2: {
        type: '',
        time: []
      },
      infoVisible: false,
      infoloading: false,
      infoData: [],
      offerInfo: [],
      offerImgs: [],
      offerOther: [],
      offerChanges: [],
      offerAccountReceipt: [],
      afterInfo: null,
      viewOrderChangeTitle: '',
      viewOrderChangeVisible: false,
      viewOrderChangeLoading: false,
      viewOrderChangeData: {
        oc: [],
        ocrlst: []
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      orderquotedata: [],
      nowTime: new Date()
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
  },
  methods: {
    viewOrderChange(row) {
      if (!this.viewOrderChangeVisible) {
        this.viewOrderChangeTitle = `更改单 ${row.num} 详情`
        this.viewOrderChangeVisible = true
      }
      this.viewOrderChangeLoading = true
      getOrderChangeDetail({ ocid: row.ocid, role: 1 }).then(response => {
        this.viewOrderChangeLoading = false
        this.viewOrderChangeData = response.data
      }).catch(() => {
        this.viewOrderChangeLoading = false
      })
    },
    Search() {
      this.currentPage = 1
      this.searchForm.search = this.searchForm.search.trim()
      this.getData()
    },
    getData() {
      this.loading = true
      let starttime = ''
      let endtime = ''
      if (this.searchForm.time !== null && this.searchForm.time !== undefined) {
        if (this.searchForm.time.length === 2) {
          starttime = this.searchForm.time[0]
          endtime = this.searchForm.time[1]
        }
      }
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        role: this.user.role,
        type: this.searchForm.type,
        starttime: starttime,
        endtime: endtime
      }
      getOrderSelectPriceList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    exportExcel() {
      if (!this.exportLoading) {
        this.exportLoading = true
        let startTime = ''
        let endTime = ''
        if (this.searchForm2.time !== null && this.searchForm2.time !== undefined) {
          if (this.searchForm2.time.length === 2) {
            startTime = this.searchForm2.time[0]
            endTime = this.searchForm2.time[1]
          }
        }
        const data = {
          type: this.searchForm2.type,
          startTime: startTime,
          endTime: endTime,
          userid: this.user.dUserid
        }
        exportOrderQueryPriceExcel(data).then(response => {
          this.exportLoading = false
          const _this = this
          const xhr = new XMLHttpRequest()
          xhr.open('GET', response.data.dPath, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status === 200) {
              const blob = this.response
              const a = document.createElement('a')
              a.download = response.data.dName + '' + response.data.dataType
              a.href = window.URL.createObjectURL(blob)
              a.target = '_blank'
              a.click()
              const h = _this.$createElement
              _this.$msgbox({
                title: '下载提示',
                message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                  h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                  h('a',
                    {
                      attrs: {
                        href: window.URL.createObjectURL(blob),
                        target: '_blank',
                        download: `${response.data.dName}.${response.data.dType}`,
                        style: 'color: #409EFF;text-decoration:underline;'
                      }
                    }, `点击这里`),
                  h('span', null, `重新下载。`)
                ]),
                showCancelButton: false,
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                  done()
                }
              }).then(action => {
              })
            }
          }
          xhr.send()
          this.dialogVisible = false
        }).catch(() => {
          this.exportLoading = false
          this.$message.error('导出失败')
        })
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$router.push({ path: '/work/order/' + row.orderid })
    },
    view(row) {
      this.infoData = row
      this.infoVisible = true
      this.infoloading = true
      this.afterInfo = null
      getOrderNuclearPriceDetail({ orderid: row.orderid }).then(response => {
        this.offerInfo = response.data.offer
        this.offerImgs = this.offerInfo.imglst
        this.offerOther = this.offerInfo.otherlst
        this.offerChanges = this.offerInfo.changelst
        this.offerAccountReceipt = this.offerInfo.dralst
        this.orderquotedata = this.offerInfo.quotes
        this.afterInfo = response.data.after
        this.infoloading = false
      }).catch(() => {
        this.infoloading = false
      })
    },
    downFile(fileid) {
      getFileInfo({ fileid: fileid }).then(response => {
        this.$message({
          message: '已下载 ' + response.data.dName + '.' + response.data.dType,
          type: 'success'
        })
        const a = document.createElement('a')
        // a.download = response.data.dName + '.' + response.data.dType
        a.href = response.data.copyPath
        a.target = '_blank'
        a.click()
        const h = this.$createElement
        this.$msgbox({
          title: '下载提示',
          message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
            h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
            h('a',
              { attrs: {
                href: response.data.copyPath,
                target: '_blank',
                download: `${response.data.dName}.${response.data.dType}`,
                style: 'color: #409EFF;text-decoration:underline;'
              }}, `点击这里`),
            h('span', null, `重新下载。`)
          ]),
          showCancelButton: false,
          confirmButtonText: '关闭',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {
        })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.ddhj-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #f2f6fc;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color: #409eff;
              }
              &:hover{
                color: #409eff;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
